import { createAction, props } from '@ngrx/store';
import { DOCSADoc } from 'src/app/core/models/docsa.model';
import { Passenger, PnrInfo } from 'src/app/core/models/itinerary.model';
import { StepMiniState } from 'src/app/core/models/models';
import {
  IReRouteModalQuote,
  IReRouteQuoteRequest,
  IRerouteUpdateQuoteRequest
} from 'src/app/core/models/re-route.model';

export const ForceRefreshSesionAndReRoute = createAction(
  '[Re-Route] Force refresh token in sesion before Re-Route quote request',
  props<{ reRouteQuoteRequest: IReRouteQuoteRequest }>()
);

export const updateLoading = createAction(
  '[Re-Route] Update the loading screen',
  props<{ isLoading: boolean }>()
);

export const saveReRouteModalQuote = createAction(
  '[Re-Route] Save Re-Route modal quote',
  props<{ reRouteModalQuote: IReRouteModalQuote }>()
);

export const saveSelectedPassengers = createAction(
  '[Re-Route] Save selected passengers',
  props<{ selectedPassengers: Passenger[] }>()
);

export const saveReRouteQuoteRequest = createAction(
  '[Re-Route] Save Re-Route quote request',
  props<{ reRouteQuoteRequest: IReRouteQuoteRequest }>()
);

export const saveStepsState = createAction(
  '[Re-Route] Save Re-Route steps state',
  props<{ step: StepMiniState }>()
);

export const updateReRouteQuoteRequest = createAction(
  '[Re-Route] Update Re-Route quote request',
  props<{ updatedData: IRerouteUpdateQuoteRequest }>()
);

export const reRouteQuoteRequest = createAction(
  '[Re-Route] Query Re-Route quote request',
  props<{ reRouteQuoteRequest: IReRouteQuoteRequest }>()
);

export const reRouteQuoteRequestSuccess = createAction(
  '[Re-Route] Query Re-Route quote request success',
  props<{ pnr: PnrInfo }>()
);

export const reRouteInitialStep = createAction('[Re-Route] Query Re-Route initial step');

export const reRouteQuoteRequestFail = createAction(
  '[Re-Route] Query Re-Route quote request failed',
  props<{ error: any }>()
);

export const resetReRouteState = createAction('[Re-Route] Reset Re-Route App State');

export const DocsaSave = createAction(
  '[Reroute Change Page] Docsa Save',
  props<{ docs: DOCSADoc[] }>()
);

export const SetReceivedFrom = createAction(
  '[Re-Route] Set Received From',
  props<{ receivedFrom: string }>()
);

export const RemoveReceivedFrom = createAction('[Re-Route] Remove Received From');
